import PropTypes from 'prop-types';
import React, { useRef } from 'react';

import useInfiniteScroll from '../useInfiniteScroll';
import ArtistCard from './ArtistCard';

const ArtistCards = ({ rows, loading, error, onRetry, hasMore, loadMore }) => {
  const sentinel = useRef(null);
  useInfiniteScroll(sentinel, { hasMore, loading, loadMore });

  return (
    <div className="ab-cards">
      {rows.map((row) => <ArtistCard key={row.id} row={row} />)}

      {error && rows.length === 0 && (
        <div className="ab-empty ab-empty--table">
          Couldn’t load artists.{' '}
          <button type="button" className="ab-clear" onClick={onRetry}>Retry</button>
        </div>
      )}
      {!error && !loading && rows.length === 0 && (
        <div className="ab-empty ab-empty--table">No artists match these filters.</div>
      )}
      {loading && <div className="ab-empty ab-empty--table">Loading…</div>}
      {hasMore && !error && <div ref={sentinel} className="ab-sentinel" />}
    </div>
  );
};
ArtistCards.propTypes = {
  rows: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool,
  onRetry: PropTypes.func.isRequired,
  hasMore: PropTypes.bool.isRequired,
  loadMore: PropTypes.func.isRequired,
};

export default ArtistCards;
